import { Platform } from "react-native";

export const ifWeb = <T>(webValue: T, nativeValue: T): T => {
  return Platform.OS === "web" ? webValue : nativeValue;
};
